// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Regions } from './Regions';
import {
  RegionsFromJSON,
  RegionsFromJSONTyped,
  RegionsToJSON,
  RegionsToJSONTyped,
} from './Regions';

/**
 *
 * @export
 * @interface ListAllPESAvailableRegions200Response
 */
export interface ListAllPESAvailableRegions200Response {
  /**
   *
   * @type {Regions}
   * @memberof ListAllPESAvailableRegions200Response
   */
  data: Regions;
}

/**
 * Check if a given object implements the ListAllPESAvailableRegions200Response interface.
 */
export function instanceOfListAllPESAvailableRegions200Response(
  value: object,
): value is ListAllPESAvailableRegions200Response {
  if (!('data' in value) || value['data'] === undefined) return false;
  return true;
}

export function ListAllPESAvailableRegions200ResponseFromJSON(
  json: any,
): ListAllPESAvailableRegions200Response {
  return ListAllPESAvailableRegions200ResponseFromJSONTyped(json, false);
}

export function ListAllPESAvailableRegions200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ListAllPESAvailableRegions200Response {
  if (json == null) {
    return json;
  }
  return {
    data: RegionsFromJSON(json['data']),
  };
}

export function ListAllPESAvailableRegions200ResponseToJSON(
  json: any,
): ListAllPESAvailableRegions200Response {
  return ListAllPESAvailableRegions200ResponseToJSONTyped(json, false);
}

export function ListAllPESAvailableRegions200ResponseToJSONTyped(
  value?: ListAllPESAvailableRegions200Response | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    data: RegionsToJSON(value['data']),
  };
}
